import { Button } from '@workspace/ui/components/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@workspace/ui/components/dialog'
import { useEffect, useState } from 'react'
import { useUserType } from '@/hooks/use-user-type'

export function WelcomeModal() {
  const [open, setOpen] = useState(false)
  const userType = useUserType()

  useEffect(() => {
    const check = () => {
      const shouldShow = localStorage.getItem('show-welcome-modal')
      if (shouldShow === 'true') {
        setOpen(true)
        localStorage.removeItem('show-welcome-modal')
      }
    }

    check()
    window.addEventListener('show-welcome-modal', check)
    return () => window.removeEventListener('show-welcome-modal', check)
  }, [])

  const handleClose = () => {
    setOpen(false)
  }

  const isInvestor = userType === 'INVESTOR'

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-2xl">You're All Set!</DialogTitle>
          <DialogDescription>
            {isInvestor
              ? "Your profile is complete and you're ready to receive inbound with completed diligence."
              : "Your profile is complete and you're ready to start practicing your pitch."}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 text-muted-foreground py-4">
          <p>
            Congratulations! You've successfully set up your SeedForge account. Here's what you can
            do next:
          </p>
          <ul className="list-disc list-inside space-y-2">
            {isInvestor ? (
              <>
                <li>
                  <span className="text-white font-medium">
                    Invite founders to pitch directly to you:
                  </span>{' '}
                  Share your SeedForge Link over X, LinkedIn, your website and email signatures
                </li>
                <li>
                  <span className="text-white font-medium">Verified dealflow:</span> SeedForge
                  surfaces only vetted founders; see the founders in action before connecting
                </li>
                <li>
                  <span className="text-white font-medium">Customized DD:</span> Upload your
                  investment thesis so we can analyze deals through your investment criteria
                </li>
              </>
            ) : (
              <>
                <li>
                  <span className="text-white font-medium">Start a pitch practice session:</span>{' '}
                  Test your pitch with our AI investor and get instant feedback
                </li>
                <li>
                  <span className="text-white font-medium">Review your sessions:</span> Track your
                  progress and see how your pitch improves over time
                </li>
                <li>
                  <span className="text-white font-medium">Refine your materials:</span> Update your
                  startup profile and documents as you iterate
                </li>
              </>
            )}
          </ul>
        </div>

        <div className="flex justify-end">
          <Button onClick={handleClose}>Get Started</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
